import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './Header.styles';

import { StepName } from '~/core/enums';
import { useRetailerDocument } from '~/core/hooks/useRetailerDocuments';
import { RetailerDocumentType } from '~/core/models';
import { isDevMode } from '~/core/utils';
import { useAppDispatch } from '~/redux/hooks';
import { goToStep } from '~/redux/slices/stepper';
import Logo from '~atoms/Logo';
import InformationModal from '~molecules/InformationModal';
import TermsAndConditionsModal from '~molecules/TermsAndConditionsModal';
import DevConfiguration from '~organisms/DevConfiguration/DevConfiguration.component';

type HeaderProps = React.PropsWithChildren<object>;

const Header = ({ children }: HeaderProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [showBasicInstallationModal, setShowBasicInstallationModal] =
    useState(false);
  const [showTnCModal, setShowTnCModal] = useState(false);
  const termsAndConditionsURL = useRetailerDocument(
    RetailerDocumentType.PRIVACY_POLICY
  );

  const [showConfiguration, setShowConfiguration] = useState(false);

  return (
    <>
      <St.LogoContainer>
        <St.LogoButton
          onClick={() => {
            dispatch(goToStep(StepName.store));
          }}
          onDoubleClick={() => {
            if (isDevMode()) {
              setShowConfiguration(!showConfiguration);
            }
          }}
        >
          <Logo />
        </St.LogoButton>

        <St.Links>
          {isDevMode() && (
            <St.Link
              onClick={() => {
                setShowConfiguration(!showConfiguration);
              }}
            >
              Developer
            </St.Link>
          )}
          <St.Link onClick={() => setShowBasicInstallationModal(true)}>
            {t('PRICING_AREA.BASIC_INSTALLATION')}
          </St.Link>
          <St.Link onClick={() => setShowTnCModal(true)}>
            {t('PRICING_AREA.TERMS_AND_CONDITIONS')}
          </St.Link>
        </St.Links>
        <InformationModal
          isVisible={showBasicInstallationModal}
          title={t('BASIC_INSTALLATION_MODAL.TITLE')}
          content={t('BASIC_INSTALLATION_MODAL.DESCRIPTION')}
          onClose={() => setShowBasicInstallationModal(false)}
        />
        <TermsAndConditionsModal
          title={t('PRICING_AREA.TERMS_AND_CONDITIONS')}
          documentURL={termsAndConditionsURL ?? ''}
          isVisible={showTnCModal}
          onClose={() => setShowTnCModal(false)}
        />
      </St.LogoContainer>

      {showConfiguration && (
        <DevConfiguration
          onClose={() => {
            setShowConfiguration(false);
          }}
        />
      )}
      <St.NavContainer>{children}</St.NavContainer>
    </>
  );
};

export default Header;
